import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import Layout from '../app/Layout';
import AccountDetailPage from './accounts/AccountDetailPage';
import AccountsPage from './accounts/AccountsPage';
import PartnerListDetailPage from './partners/PartnerListDetailPage';
import PartnerListsPage from './partners/PartnerListsPage';
import RoleDetailPage from './roles/RoleDetailPage';
import RolesPage from './roles/RolesPage';
import UserDetailPage from './users/UserDetailPage';
import UsersPage from './users/UsersPage';
import OnboardingPage from './users/onboarding/OnboardingPage';

/**
 * Routes of the back-office. The root sends to Users rather than to a dashboard that
 * would have nothing to say.
 *
 * No account in the path. The users list opens on every account the actor may see and
 * the account is one of its filters: an identifier in the URL would have made the
 * screen unreachable without knowing one.
 */
const Pages = () => {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Navigate to="/utilisateurs" replace />} />
                    <Route path="/utilisateurs" element={<UsersPage />} />
                    {/* Before the `:userId` route: « nouveau » is a screen, not an
                        identifier, and the router would otherwise read it as one. */}
                    <Route path="/utilisateurs/nouveau" element={<OnboardingPage />} />
                    {/* The person, not the membership: the sheet gathers every membership
                        of the person that the actor may see. */}
                    <Route path="/utilisateurs/:userId" element={<UserDetailPage />} />
                    {/* PCG-141. The account IS in the path here, and that is not a
                        contradiction with the note above: this screen is *about* one
                        account, where the users list is about users and merely narrows to
                        one. A subject belongs in the address, a filter does not. */}
                    <Route path="/comptes" element={<AccountsPage />} />
                    <Route path="/comptes/:accountId" element={<AccountDetailPage />} />
                    <Route path="/roles" element={<RolesPage />} />
                    <Route path="/roles/:roleId" element={<RoleDetailPage />} />
                    {/* A referential of the platform, so a screen of its own and not a
                        panel on an account: a partner list carries no `organization_id`
                        and belongs to no client. The dashboard catalogue went the other
                        way, onto the account it is the object of. */}
                    <Route path="/listes-de-partenaires" element={<PartnerListsPage />} />
                    {/* La liste EST le sujet de cette page, donc son identifiant est
                        dans l'adresse, comme pour un compte. */}
                    <Route path="/listes-de-partenaires/:partnerListId" element={<PartnerListDetailPage />} />
                    {/* Anything else lands on the only screen there is, rather than on a
                        blank page. There is no 404 to design yet. */}
                    <Route path="*" element={<Navigate to="/utilisateurs" replace />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
};

export default Pages;
